<template>
    <div>
        <!-- <b-form-group  label="Attachments"  label-for="upload_file">
        <b-form-file v-model="files"  id="upload_file"  placeholder="Attach File" accept=".jpg, .png, .gif, .pdf , .doc , .docx" multiple plain v-on:input="onChange"><i class="fa-solid fa-paperclip"></i></b-form-file>
       </b-form-group> 

              <div>
                      <ul>
                         <li v-for="(thisFile,index) in filesAccumulated" :key="index" class="list-style">
                        
                          {{ thisFile.name }} 

                          <span @click="removeFile(index)" class="span" style="cursor: pointer;"><i class="fa fa-times" aria-hidden="true"></i></span>
                        </li>
                       
                         </ul>
                 </div> 


        <!-Extra for frag and drop------------->
        <!----------<div class="card">
            <div class="top">
                <p>Drag & drop  here </p>
            </div>
            <div class="drag-area">
              <span>
                Drag & Drop here or
                <b-form-group  label="Choose"  label-for="upload_file" class="select">
                    <b-form-file v-model="files"  id="upload_file"  placeholder="Attach File" accept=".jpg, .png, .gif, .pdf , .doc , .docx" multiple plain v-on:input="onChange"><i class="fa-solid fa-paperclip"></i></b-form-file>
                 </b-form-group>
              </span> 
              
              <div class="select">Drop files here</div>
            </div>
            <div class="container">
                <div class="image">
                    <span class="delete">&times;</span>
                    <div class="file_name">
                      <ul>
                         <li v-for="(thisFile,index) in filesAccumulated" :key="index" class="list-style">
                        
                          {{ thisFile.name }} 

                          <span @click="removeFile(index)" class="span" style="cursor: pointer;"><i class="fa fa-times" aria-hidden="true"></i></span>
                        </li>
                       
                         </ul>
                 </div> 

                </div>
            </div>
        </div> -->

       
  <!--------Extra for frag and drop------------->


  <!-------------Elastic drag and drop---------------------->

    <div class="row">
         <div class="col-sm-12">
            <template v-if="multiple==true">
             <b-form-group id="form_file_group" class="custom-file-uploader"  :label="labelname" label-for="files">
                <!-- Start: Rejwan: 30-04-2025 File Upload -->
             <b-form-file  id="files" :accept="accept"  :multiple="multiple"  v-model=" files" @change="onChange" placeholder="Drag and drop files here or click to browse" drop-placeholder="Drop file here..." aria-describedby="form_file_feedback" data-vv-as="File Uploader">
                <template #file-name></template> <!-- Mustafijur: gf_unified: 04-08-2026 -->
             </b-form-file>
                <!-- End: Rejwan: 30-04-2025 File Upload -->
             <b-form-invalid-feedback id="form_file_feedback">{{ veeErrors.first('files') }}</b-form-invalid-feedback>
            
             <div class="mt-3">
                <ul class="file-lust">
                        <li v-for="(thisFile,index) in filesAccumulated" :key="index" class="list-style">
                        
                        {{ shortenFileName(thisFile.name) }} 

                        <span @click="removeFile(index)" class="span" style="cursor: pointer;"><i class="fa fa-times" aria-hidden="true"></i></span>
                        </li>
                
                </ul>
             </div>
             
            </b-form-group>
            </template>

            <template v-else>
                <b-form-group id="form_file_group" class="custom-file-uploader"  :label="labelname" label-for="files">
             <b-form-file  id="files" :accept="accept"    v-model="files" v-on:input="onChange" placeholder="Drag and drop files here or click to browse" drop-placeholder="Drop file here..." aria-describedby="form_file_feedback" data-vv-as="File Uploader">
                <template #file-name></template> <!-- Mustafijur: gf_unified: 04-08-2026 -->
             </b-form-file>
             <b-form-invalid-feedback id="form_file_feedback">{{ veeErrors.first('files') }}</b-form-invalid-feedback>
            
             <div class="mt-3">
                      <ul class="file-lust">
                         <li v-for="(thisFile,index) in filesAccumulated" :key="index" class="list-style">
                        
                          {{ shortenFileName(thisFile.name) }} 

                          <span @click="removeFile(index)" class="span" style="cursor: pointer;"><i class="fa fa-times" aria-hidden="true"></i></span>
                        </li>
                       
                         </ul>
             </div>
             
            </b-form-group>
            </template>
            
          </div>
           
     </div>
    </div>
  </template>

<script>
export default{

    props:[

        'labelname','accept','multiple'

    ],

    data(){

        return{

            files: [],
            labelName:this.labelName,
            filesAccumulated: [],

        }
    },
    methods:{
 
        cleardata:function(){
            this.files=[];
            this.filesAccumulated=[];
           
        },
        onChange(event) {
            if(!this.checkFileType(event, this.labelName, this.accept.replace(/\s+/g, '').split(','))){
                return true;
            }
            if(this.multiple==true){
                const selectedFiles = Array.from(event.target.files);
                let selectedFileLength = selectedFiles.length;
                // Check for duplicate file names
                for (let file of selectedFiles) {
                    const isDuplicate = this.filesAccumulated.some(existingFile => 
                        existingFile.name === file.name
                    );
                    if (isDuplicate) {
                        this.$bvToast.toast(`File "${file.name}" already exists.`, {
                            title: 'Duplicate File',
                            variant: 'danger',
                            solid: true
                        });
                        continue; // Skip adding this duplicate file
                    }
                    
                    if((this.filesAccumulated.length) < 10){
                        this.filesAccumulated.push(file);
                    } else {
                        this.$bvToast.toast('You can upload a maximum of 10 files.', {
                            title: 'File Upload Limit Exceeded',
                            variant: 'danger',
                            solid: true
                        });
                        break; // Exit the loop if limit is reached
                    }
                }
            } else {
                this.filesAccumulated.push(this.files);
            } 
            this.$emit('childToParent',this.filesAccumulated);
        },
        shortenFileName(name) {
            if (!name) return '';

            const lastDotIndex = name.lastIndexOf('.');
            const extension = lastDotIndex !== -1 ? name.slice(lastDotIndex) : '';
            const baseName = lastDotIndex !== -1 ? name.slice(0, lastDotIndex) : name;

            if (baseName.length > 33) {
                return baseName.slice(0, 33) + '....' + extension;
            }

            return name;
        },

      removeFile(x){
            
            let up_file;
            up_file = this.filesAccumulated.splice(x,1);
            // console.log("Remove file");
            // console.log(this.filesAccumulated);
            this.$emit('childToParent',this.filesAccumulated);
           },
           mounted(){
            this.filesAccumulated = []
           }
    }
}
</script>

<style scoped>
.list-style{
    display: inline;
    list-style-type: none;
    background-color: lightgrey;
    padding: 10px;
    border-radius: 5px;
    margin-right: 4px ;
}
.span{
   
    padding: 5px;
}

.card{
    width:100%;
    padding: 10px;
    box-shadow: 0 0 5px #ffdfdf;
    border-radius: 5px;
    overflow: hidden;
}
.card-top{

    text-align: center;
}
.card p{
    font-weight: bold;
    color: #fe0000;
}
.card .drag-area{
    height: 150px;
    border-radius: 5px;
    border: 2px dashed #fe0000;
    background: #f4f3f9;
    color: #fe0000;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: center;
    -webkit-user-select: none;
    margin-top:10px;
}

.card .drag-area .visible{
    font-size:18px;
}

.card .select{
    color: #5256ad;
    margin-left: 5px;
    cursor: pointer;
    transition: 0.4s
}
.card .select:hover{

    opacity: 0.6;
}
.card .container{
   width: 100%;
   height: auto;
   display: flex;
   justify-content: flex-start;
   align-items: flex-start;
   flex-wrap: wrap;
   max-height: 200px;
   position: relative;
   margin-bottom: 8px;
   
}

.card .container .image{

    width: 75px;
    margin-right: 5px;
    height: 75px;
    position: relative;

}

.card .container .image img{
 width: 100%;
 height: 100%;
 border-radius: 5px;
}

.card .container .image span{
    position:absolute;
    top:-2px;
    right: 9px;
    font-size:20px;
    cursor:pointer;

}

.card input,
.card .drag-area .on-drop,
.card .drag-area.dragover .visible{
    display: none;
}
.delete{
    z-index: 999;
    color: #fe0000;
}
.file_name{

    width: 100px;

}
.file-lust{
    display: flex;
    flex-direction: column;
    gap: 4px;
}

</style>
